export default {
  WEBSITE: 'https://www.yuan365.com',
  WEBSITEINTL: 'https://intl.yuan365.com',
  // APIHOST: 'https://mobvoi-mw-test.weta365.com'
  APIHOST: 'https://chat.mobvoi.com',
  AVATARURL: 'wss://streaming-neural-avatar.mobvoi.com/websocket/avatar'
}
